import {
  getArticlesByQuery,
  getArticleTagsWithCount,
  getRecommendedArticleTags,
} from "../../../services/articlesService";
import {
  BROWSE_COUNT_QUERY_KEY,
  BROWSE_MOBILE_MEDIA_QUERY,
  BROWSE_QUERY_KEY,
  BROWSE_RECOMMENDED_TAGS_QUERY_KEY,
  BROWSE_TAGS_QUERY_KEY,
} from "./constants";
import {
  buildArticleTagsQueryParamsString,
  getBrowseFilterState,
} from "./utils/browseUtils";

// Query definitions shared by the Browse hooks and the /browse route loader, so
// both land on one cache entry. Per-observer options (select, placeholderData)
// stay in the hooks.
const ONE_MINUTE = 60 * 1000;

export const browseArticlesQuery = (queryParamsString = "") => ({
  queryKey: [BROWSE_QUERY_KEY, queryParamsString],
  queryFn: () => getArticlesByQuery(queryParamsString),
  staleTime: ONE_MINUTE,
});

export const browseArticleCountQuery = (queryParamsString = "") => ({
  queryKey: [BROWSE_COUNT_QUERY_KEY, queryParamsString],
  queryFn: () => getArticlesByQuery(queryParamsString),
  staleTime: ONE_MINUTE,
});

export const articleTagsQuery = (queryParamsString) => ({
  queryKey: [BROWSE_TAGS_QUERY_KEY, queryParamsString],
  queryFn: () => getArticleTagsWithCount(queryParamsString),
  staleTime: ONE_MINUTE,
});

export const recommendedTagsQuery = (tagNamesParam) => ({
  queryKey: [BROWSE_RECOMMENDED_TAGS_QUERY_KEY, tagNamesParam],
  queryFn: () => getRecommendedArticleTags(tagNamesParam),
  staleTime: ONE_MINUTE,
});

const isNarrowViewport = () => {
  if (typeof window === "undefined" || !window.matchMedia) {
    return false;
  }
  return window.matchMedia(BROWSE_MOBILE_MEDIA_QUERY).matches;
};

// What the generic /browse page (no locked page tags, keyword search on)
// requests on first render for the given URL search params.
export const browseRouteQueries = (searchParams) => {
  const { tags, articleListQueryParamsString, articleCountQueryParamsString } =
    getBrowseFilterState(searchParams);

  const queries = [
    browseArticlesQuery(articleListQueryParamsString),
    browseArticleCountQuery(articleCountQueryParamsString),
    articleTagsQuery(buildArticleTagsQueryParamsString(tags)),
  ];

  // Below the mobile breakpoint FilterManager doesn't mount RecommendedTags, so
  // prefetching them would add a request the page never makes.
  if (!isNarrowViewport()) {
    queries.push(recommendedTagsQuery(tags.join(",")));
  }

  return queries;
};
